class CollectionShop extends HTMLElement {
  colors;
  weights;
  input;
  image;
  form;
  options;
  variants;
  prices;
  quantityInputs;
  weightLabel;
  quickAdd;
  variantId;
  variant;
  triggers;
  thumbnail;
  quantity;
  quantitySelector;
  colorsWrapper1;
  colorsWrapper2;

  constructor() {
    super();
  }

  connectedCallback() {
    if (this.dataset.quickAdd !== 'true') return;

    this.colors = this.querySelector('.swatch-element.color') || this.querySelector('.blanket-options_select');
    this.weights = this.querySelector('.swatch');
    this.input = this.querySelector('[name="id"]');
    this.image = this.querySelector('img');
    this.form = this.querySelector('.quick-add-form');
    this.options = this.weights ? [this.colors.querySelector('input:checked').value, this.weights.querySelector('input:checked').value] : [this.colors.querySelector('input:checked').value];
    this.variants = window.theme.collectionProducts[this.dataset.product];
    this.weightLabel = this.querySelector('[data-weight]');
    this.prices = this.querySelectorAll('[data-price]');
    this.quantityInputs = this.querySelectorAll('[data-quantity]');
    this.quickAdd = this.querySelector('.quick-add');
    this.discount = this.dataset.discount;
    this.variantId = parseInt(this.input.value);
    this.triggers = this.querySelectorAll('[data-quick-add-trigger]');
    this.thumbnail = this.querySelector('.quick-add-thumbnail img');
    this.quantity = 1;
    this.isGiftCard = this.colors ? this.colors.classList.contains('blanket-options_select') : false;
    this.quantitySelector = this.querySelector('.quantity');
    this.colorsWrapper1 = this.querySelector('.quick-add_colors-1');
    this.colorsWrapper2 = this.querySelector('.quick-add_colors-2');
    this.variant = this.variants.find(((v) => v.id === this.variantId).bind(this));
    if (this.triggers)
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.handleTrigger.bind(this));
      });
    if (this.quantitySelector)
      this.quantitySelector.addEventListener('click', this.handleQuantity.bind(this));
    if (this.colors) this.colors.addEventListener('change', this.handleColors.bind(this));
    if (this.weights) this.weights.addEventListener('change', this.handleWeights.bind(this));
    if (this.form) this.form.addEventListener('submit', this.handleForm.bind(this));

    if (this.isGiftCard)
      this.colors.addEventListener('click', function (e) {
        if (e.target.tagName === 'INPUT') return; else if (this.colors.hasAttribute('open')) this.colors.removeAttribute('open'); else this.colors.setAttribute('open', '');
      }.bind(this))

    this.showOnlyAvailableSwatches()
  }

  showOnlyAvailableSwatches(type = 'color') {
    if (!this.colors || this.isGiftCard || !window.theme.hideUnavailableWeights || !this.weights || !this.variant.hasWeight) return;
    if (type === 'color') {
      this.colors.querySelectorAll('input').forEach(color => {
        const find = this.variants.find(variant => variant.options[0] === color.value && variant.available)
        if (!find) color.nextElementSibling.setAttribute('hidden', '')
        else color.nextElementSibling.removeAttribute('hidden')
      })

      if (!this.variant.available) {
        const weight = [...this.weights.querySelectorAll('input')].find(weight => {
          const find = this.variants.find(variant => variant.options[1] === weight.value && variant.available && variant.options[0] === this.variant?.options?.[0])
          return !!find
        })

        weight.nextElementSibling.click()
      } else {
        this.weights.querySelectorAll('input').forEach(weight => {
          const find = this.variants.find(variant => variant.options[1] === weight.value && variant.available && variant.options[0] === this.variant?.options?.[0])
          if (!find) weight.nextElementSibling.setAttribute('hidden', '')
          else weight.nextElementSibling.removeAttribute('hidden')
        })
      }
    } else {
      this.weights.querySelectorAll('input').forEach(weight => {
        const find = this.variants.find(variant => variant.options[1] === weight.value && variant.available && variant.options[0] === this.variant?.options?.[0])
        if (!find) weight.nextElementSibling.setAttribute('hidden', '')
        else weight.nextElementSibling.removeAttribute('hidden')
      })

      if (!this.variant.available) {
        const color = [...this.colors.querySelectorAll('input')].find(color => {
          const find = this.variants.find(variant => variant.options[0] === color.value && variant.available && variant.options[1] === this.variant?.options?.[1])
          return !!find
        })

        color.nextElementSibling.click()
      }
    }
  }

  getTotalPrice() {
    const intPrice = parseInt(this.variant.price.replace('$', ''));
    
    let total = intPrice * this.quantity;
    if (this.discount) {
      const discountAmount = total * (this.discount / 100);
      total -= discountAmount;
    }
    return '$' + Math.round(total);
  }

  switchColors(original) {
    if (window.innerWidth > 989 || (window.innerWidth < 990 && !this.colorsWrapper2))
      return;
    let initial;
    let final;
    if (original) {
      initial = this.colorsWrapper2;
      final = this.colorsWrapper1;
    }
    else {
      initial = this.colorsWrapper1;
      final = this.colorsWrapper2;
    }
    const element = initial.removeChild(initial.querySelector('fieldset'));
    final.appendChild(element);
  }

  handleTrigger() {
    if (this.quickAdd.hasAttribute('open')) {
      this.quickAdd.removeAttribute('open');
      document.body.classList.remove('body_fade');
      document.body.classList.remove('header_fade');
      this.switchColors(true);
    }
    else {
      this.quickAdd.setAttribute('open', '');
      document.body.classList.add('body_fade');
      document.body.classList.add('header_fade');
      this.switchColors(false);
    }
  }

  handleQuantity(e) {
    const el = e.target;
    const isMinus = el.classList.contains('quantity__button-minus');
    const isPlus = el.classList.contains('quantity__button-plus');
    if (el.tagName !== 'BUTTON' || (isMinus && this.quantity === 1) || (isPlus && this.quantity === 99))
      return;
    this.quantity = isMinus ? this.quantity - 1 : isPlus ? this.quantity + 1 : this.quantity;
    this.quantityInputs.forEach((input) => {
      input.value = this.quantity.toString();
    });
    this.form.querySelector('button > [data-price]').innerHTML = this.getTotalPrice();
  }

  handleColors(e) {
    this.options[0] = e.target.value;


    if (this.isGiftCard) {
      this.variant = this.variants.find((vari) => vari.options[0] === this.options[0] && vari.options[1] === this.options[1]);
    }
    else {
      this.image.src = '';
      const oldSizes = this.variant.sizes.join(',');
      this.variant = this.variants.find((vari) => vari.options[0] === this.options[0] && vari.options[1] === this.options[1]);
      if (!this.variant)
        this.variant = this.variants.find((vari) => vari.options[0] === this.options[0]);
      if (oldSizes !== this.variant.sizes.join(',')) {
        const input = this.querySelector('input[value="' + this.variant.options[1] + '"]');
        input.click();
        this.options[1] = this.variant.options[1];
      }
      this.image.src = this.variant.image;
      if (this.thumbnail) this.thumbnail.src = this.variant.original_image;
    }

    


    this.input.value = this.variant.id;
    if (this.variant.id == '44420337828026' || this.variant.id == '44420338254010' || this.variant.id == '44420338647226' ) {
      this.prices.forEach((price) => {
        price.innerHTML = price.parentElement.tagName === 'BUTTON' ? '$49' : '$49';
      });
    }
    else {
      this.prices.forEach((price) => {
        price.innerHTML = price.parentElement.tagName === 'BUTTON' ? this.getTotalPrice() : this.variant.price;
      });
    }
    if (this.variant.available)
      this.removeAttribute('soldout');
    else
      this.setAttribute('soldout', '');

    this.showOnlyAvailableSwatches()
  }

  handleWeights(e) {
    this.options[1] = e.target.value;
    this.variant = this.variants.find((variant) => variant.options[0] === this.options[0] && variant.options[1] === this.options[1]);
    this.input.value = this.variant.id;

    if (this.variant.hasWeight)
      this.weightLabel.innerHTML = this.options[1] + ' lbs ' + window.theme.getDimension(this.options[1]);
    else if (this.variant.hasSize && !this.isGiftCard) {
      let option = this.options[1];
      if (option === 'Small' && this.variant.title === 'Pupper Pod') option = 'Small1';
      else if (option === 'Medium' && this.variant.title === 'Pupper Pod') option = 'Medium1';
      this.weightLabel.innerHTML = this.options[1] + window.theme.getDimension(option);
    } else
      this.weightLabel.innerHTML = this.options[1];

    this.prices.forEach(((price) => {
      if (this.variant.options[0] == 'Kaleidoscope' || this.variant.options[0] == 'Flora' || this.variant.options[0] == 'Mist'  ) {
        price.innerHTML = price.parentElement.tagName === 'BUTTON' ? '$49' : '$49';
      } else {
      price.innerHTML = price.parentElement.tagName === 'BUTTON' ? this.getTotalPrice() : this.variant.price;
      }
    }).bind(this));

    this.image.src = this.variant.image;

    if (this.variant.available)
      this.removeAttribute('soldout');
    else
      this.setAttribute('soldout', '');

    this.showOnlyAvailableSwatches('weight')
  }

  handleForm(e) {
    e.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute('disabled', 'true');
    submitButton.classList.add('loading');
    const body = JSON.stringify({
      ...JSON.parse(window.theme.utils.serializeForm(this.form))
    });
    fetch('/cart/add', { ...window.theme.fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        window.theme.cart.render(true);
      })
      .catch((err) => {
        console.error(err);
        e.target.submit();
      })
      .finally(() => {
        this.quickAdd.removeAttribute('open');
        this.switchColors(true);
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}

customElements.define('collection-shop', CollectionShop);

document.querySelectorAll('.quick-add').forEach(element => {
  element.addEventListener('click', function() {
      setTimeout(() => {
          this.classList.add('active-click');
      }, 500);
  });
});
